import pricingTiers from "../components/landing/pricing-tiers.json";

const PLAN_ID_ALIASES = Object.freeze({
  pro: "basic",
  trial: "free",
  free_trial: "free",
  "free-trial": "free",
  freetrial: "free",
});

const PLAN_PUBLIC_ID_BY_STORED_ID = Object.freeze({
  free: "free",
  essentials: "essentials",
  basic: "pro",
  enterprise: "enterprise",
});

function normalizePlanId(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return PLAN_ID_ALIASES[normalized] || normalized;
}

function toTitle(value) {
  return String(value || "")
    .trim()
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part.slice(0, 1).toUpperCase() + part.slice(1))
    .join(" ");
}

const DISPLAY_TIER_BY_ID = new Map(
  (Array.isArray(pricingTiers) ? pricingTiers : [])
    .filter((tier) => tier && typeof tier.id === "string")
    .map((tier) => [normalizePlanId(tier.id), tier])
);

export function getDisplayTierById(planId) {
  return DISPLAY_TIER_BY_ID.get(normalizePlanId(planId)) || null;
}

export function getStoredPlanId(planId) {
  return normalizePlanId(planId);
}

export function getPlanPublicId(planId) {
  const normalizedPlanId = normalizePlanId(planId);
  return PLAN_PUBLIC_ID_BY_STORED_ID[normalizedPlanId] || normalizedPlanId;
}

export function getPlanDisplayName(planId, fallbackName = "") {
  const displayTier = getDisplayTierById(planId);
  if (displayTier?.name) return String(displayTier.name).trim();

  const fallback = String(fallbackName || "").trim();
  if (!fallback) return toTitle(getPlanPublicId(planId));
  if (fallback.toLowerCase() === "basic") return "Pro";
  return fallback;
}

export function getPlanIdentity(planId, fallbackName = "") {
  const storedId = normalizePlanId(planId);
  return {
    storedId,
    publicId: getPlanPublicId(storedId),
    displayName: getPlanDisplayName(storedId, fallbackName),
  };
}

export function applyPlanDisplayCopy(plan) {
  if (!plan || typeof plan !== "object") return plan;

  const displayTier = getDisplayTierById(plan.id);
  if (!displayTier) {
    return { ...plan };
  }

  return {
    ...plan,
    name: String(displayTier.name || plan.name || ""),
    description: String(displayTier.description || plan.description || ""),
    billing: String(displayTier.billing || plan.billing || ""),
    cta: String(displayTier.cta || plan.cta || ""),
    features: Array.isArray(displayTier.features)
      ? displayTier.features.map((entry) => String(entry || "").trim()).filter(Boolean)
      : Array.isArray(plan.features)
      ? plan.features
      : [],
    featured: typeof displayTier.featured === "boolean" ? displayTier.featured : !!plan.featured,
  };
}
